var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgLocker = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M68.935 60.892v22.226H17.382V14.381h51.553v17.914"
  }), React.createElement("path", {
    fill: color,
    d: "M37 27.533V34H17V14h20v5.212M69 76.856V83H37V64h32v4.952"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M68.934 60.892V83.12H17.382V14.38h51.553v17.915"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M36.714 29.417h32.22l17.184-4.296v41.831l-17.184-3.167h-32.22"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M36.714 29.417h32.22l17.184-4.296v41.831l-17.184-3.167h-32.22"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M36.715 33.713H17.38v23.63h19.334v-23.63Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M31.5 37.5h-9v9h9v-9Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M24 50.899h6M36.714 83.026V14.381"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M73.23 35.862H43.159v21.48h30.073v-21.48Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M65.1 53.046h2.74"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m62.49 43.91-4.296-3.035-4.297 3.036v-8.05h8.594v8.05Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M26 19.125h-2.5c-.76 0-1.375.616-1.375 1.375V23c0 .207.168.375.375.375H26a.375.375 0 0 0 .375-.375v-3.5a.375.375 0 0 0-.375-.375Zm-2.5.75h2.125v2.75h-2.75V20.5c0-.345.28-.625.625-.625Zm4.5-.75a.375.375 0 0 0-.375.375V23c0 .207.168.375.375.375h3.5a.375.375 0 0 0 .375-.375v-2.5c0-.76-.616-1.375-1.375-1.375H28Zm.375 3.5v-2.75H30.5c.345 0 .625.28.625.625v2.125h-2.75ZM31.125 26v-1a.375.375 0 0 1 .75 0v1a.375.375 0 0 1-.75 0Zm0 1.5c0 .345-.28.625-.625.625h-1a.375.375 0 0 0 0 .75h1c.76 0 1.375-.616 1.375-1.375a.375.375 0 0 0-.75 0Zm-2.75 0v1a.375.375 0 0 1-.75 0v-1a.375.375 0 0 1 .75 0ZM30 25.375a.375.375 0 0 0 0-.75H28a.375.375 0 0 0-.375.375v1a.375.375 0 0 0 .75 0v-.625H30ZM22.125 25c0-.207.168-.375.375-.375H26c.207 0 .375.168.375.375v3.5a.375.375 0 0 1-.375.375h-2.5c-.76 0-1.375-.616-1.375-1.375V25Zm.75.375V27.5c0 .345.28.625.625.625h2.125v-2.75h-2.75Zm.625-4.688c0-.103.084-.187.187-.187h1.125c.104 0 .188.084.188.187v1.125a.187.187 0 0 1-.188.188h-1.125a.188.188 0 0 1-.187-.188v-1.125Zm5.688-.187a.188.188 0 0 0-.188.187v1.125c0 .104.084.188.188.188h1.125a.188.188 0 0 0 .187-.188v-1.125a.188.188 0 0 0-.187-.187h-1.125ZM23.5 26.188c0-.104.084-.188.187-.188h1.125c.104 0 .188.084.188.188v1.125a.188.188 0 0 1-.188.187h-1.125a.188.188 0 0 1-.187-.187v-1.125ZM29.188 26a.187.187 0 0 0-.188.188v1.125c0 .103.084.187.188.187h1.125a.188.188 0 0 0 .187-.187v-1.125a.188.188 0 0 0-.187-.188h-1.125Z",
    clipRule: "evenodd"
  }));
};
export default SvgLocker;